// https://github.com/vueuse/vueuse/issues/4198
// https://github.com/nuxt/nuxt/issues/24788

import type { RouteParamValueRaw } from 'vue-router'
import { useRouteQuery as _useRouteQuery } from '@vueuse/router'

type RouteQueryValueRaw = RouteParamValueRaw | string[]

interface ReactiveRouteOptions {
  /**
   * Mode to update the router query, ref is also acceptable
   *
   * @default 'replace'
   */
  mode?: MaybeRef<'replace' | 'push'>
  /**
   * Route instance, use `useRoute()` if not given
   */
  route?: ReturnType<typeof useRoute>
  /**
   * Router instance, use `useRouter()` if not given
   */
  router?: ReturnType<typeof useRouter>
}

interface ReactiveRouteOptionsWithTransform<V, R> extends ReactiveRouteOptions {
  transform?: (val: V) => R
}

/**
 * Extends the original `useRouteQuery` to use the Nuxt's route and router
 */
export function useRouteQuery(name: string): Ref<undefined | null | string | string[]>
export function useRouteQuery<T extends RouteQueryValueRaw = RouteQueryValueRaw, K = T>(
  name: string,
  defaultValue?: MaybeRefOrGetter<T>,
  options?: ReactiveRouteOptionsWithTransform<T, K>): Ref<K>
export function useRouteQuery<T extends RouteParamValueRaw = RouteParamValueRaw, K = T>(
  name: string,
  defaultValue?: T,
  options: ReactiveRouteOptionsWithTransform<T, K> = {}
) {
  return _useRouteQuery<T, K>(name, defaultValue, {
    ...options,
    route: useRoute(),
    router: useRouter()
  })
}
